<template>
    <div v-if="isVisible" class="form-item conditions" :class="[item.data.htmloptions, { 'is-invalid' : isInvalid }]">

        <Label v-if="item.data.question != ''" :item="item" :is-invalid="isInvalid" :errors="errors" />

        <div class="checkbox-item">
            <div class="text" v-html="item.data.textBox"></div>

            <input
                :id="item.data.id"
                type="checkbox"
                :name="item.data.id"
                value="1"
            >
            <i class="icon-form-checkmark"></i>
        </div>
        <error-message v-if="errorMessage">{{ errorMessage }}</error-message>
        <!-- <label v-if="item.data.confirmLabel" :for="item.data.id"> {{ item.data.confirmLabel }}</label> -->
    </div>
</template>

<script>
import Label from "../components/Label.vue";
import ErrorMessage from "../components/ErrorMessage.vue"
import errorMixin from "../mixins/error";
import logicMixin from "../mixins/logic";

export default {
    name: 'Terms',
    components: { Label, ErrorMessage },
    mixins: [ errorMixin, logicMixin ],
    props: {
        item: {
            type: Object
        }
    }
};
</script>